import React, {Fragment, useEffect, useState} from 'react';
import moment from "moment";
import CUFormService from "../../../../services/CUFormService";
import FormService from "../../../../services/FormsService";
import Color from "color";

const TemplateCUBavis = (props) => {

    const [entity, setEntity] = useState({name:'', email:'', phone:'', cp:'', city: '', address:'', address2:'', stamp:''})
    const cuFormService = new CUFormService();
    const formService = new FormService();
    const [imgBase64, setImgBase64] = useState();
    const [annexes, setAnnexes] = useState();

    useEffect(()=>{
        setEntity(cuFormService.getEntityInfo())
        setAnnexes(formService.getEntityAnnexes())
    }, [])

    useEffect(()=>{

    }, [annexes])

    useEffect( ()=>{
            (entity && entity.stamp && entity.stamp != '')?ImgLinktoDataURL("/storage/images/entities/"+entity.id+"/"+entity.stamp):null;
    },[entity])

    const ImgLinktoDataURL =(url)=>{
        let xhr = new XMLHttpRequest();
        xhr.onload = function() {
            var reader = new FileReader();
            reader.onloadend = function() {
                setImgBase64(reader.result)
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    return (
        <div className="ue-section">
            <div className="text-left text-underline">
                <h3>ARTICLE 8 - Avis et Observation</h3>
            </div>
            <br/>
            <p>
                <br/>
                <br/>
                <br/>
            </p>
        </div>
    );
};

export default TemplateCUBavis;
